import React from 'react';
import { NavLink } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

/**
 * 子菜单组件
 * @param {Object} props - 组件属性
 * @param {Array} props.items - 菜单项数组，每项包含：{path, icon, messageId, isActive, messageValues}
 * @param {string} props.className - 子菜单容器类名
 * @param {function} props.onItemClick - 菜单项点击事件
 * @param {Object} props.customStyle - 自定义样式
 */
const SubMenu = ({
  items,
  className,
  onItemClick,
  customStyle,
  styles
}) => {
  if (!items || items.length === 0) return null;

  return (
    <div className={className} style={customStyle}>
      <ul>
        {items.map((item, index) => (
          <li 
            key={`${item.messageId}-${index}`} 
            className={`${item.isActive || ''} ${item.extraClass || ''}`}
            style={item.customStyle}
          >
     
              <NavLink to={item.path} onClick={onItemClick}>
                <div style={{ position: 'relative', width: '40px', margin:'0 auto'}}>
                  {item.icon && <i className={item.icon} />}
                  {item.new && <div className={styles.new}> 
                    <FormattedMessage 
                      id={'new_tag'}  
                    />
                  </div>}
                </div>
                <FormattedMessage 
                  id={item.messageId} 
                  values={item.messageValues || {}} 
                />
               
              </NavLink>
    
          </li>
        ))}
      </ul>
    </div>
  );
};

SubMenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      icon: PropTypes.string,
      messageId: PropTypes.string.isRequired,
      isActive: PropTypes.string,
      messageValues: PropTypes.object,
      extraClass: PropTypes.string,
      customStyle: PropTypes.object
    })
  ).isRequired,
  className: PropTypes.string.isRequired,
  onItemClick: PropTypes.func,
  customStyle: PropTypes.object,
  styles: PropTypes.object
};

export default SubMenu; 